module.exports = __webpack_public_path__ + "static/img/edit-icon-2375785_960_720.740d2356.png";